import { apiService } from './api';

export interface ProductBundleItem {
  id: number;
  productId: number;
  productName: string;
  quantity: number;
  notes?: string;
}

export interface ProductBundle {
  id: number;
  code: string;
  name: string;
  description?: string;
  price: number;
  sortOrder: number;
  isActive: boolean;
  items: ProductBundleItem[];
}

export interface BundleItemInputDTO {
  productId: number;
  quantity: number;
  notes?: string;
}

export interface CreateProductBundleDTO {
  code: string;
  name: string;
  description?: string;
  price: number;
  sortOrder: number;
  isActive: boolean;
  items: BundleItemInputDTO[];
}

export type UpdateProductBundleDTO = CreateProductBundleDTO;

/**
 * The backend wraps every payload in ApiResponse<T>, so each call unwraps exactly once
 * via `response.data.data`. The bundle list endpoint returns every bundle for the company
 * rather than a page, so there is no pagination metadata to carry here.
 */
const productBundleService = {
  getAll: async () => {
    const response = await apiService.get<ProductBundle[]>('/product-bundles');
    return response.data.data ?? [];
  },

  getById: async (id: number) => {
    const response = await apiService.get<ProductBundle>(`/product-bundles/${id}`);
    return response.data.data;
  },

  create: async (dto: CreateProductBundleDTO) => {
    const response = await apiService.post<ProductBundle>('/product-bundles', dto);
    return response.data.data;
  },

  update: async (id: number, dto: UpdateProductBundleDTO) => {
    const response = await apiService.put<ProductBundle>(`/product-bundles/${id}`, dto);
    return response.data.data;
  },

  delete: (id: number) => apiService.delete(`/product-bundles/${id}`),
};

export default productBundleService;
